import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { TreatmentPlanStatus } from '../constants/general';
import { areUserRolesIn } from '../../../../helpers';
import { Roles } from '../../../../constants';

import type { RootState } from '../../../../store';
import type { ITreatmentPlanStatus } from '../../../../utils/types';

export function useTreatmentPlanEditable() {
  const { user } = useSelector((state: RootState) => state.auth);
  const { provider } = useSelector((state: RootState) => state.providers);
  const { current: treatmentPlan, statuses: tpStatuses } = useSelector(
    (state: any) => state.treatmentPlans,
  );
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [editableTPStatusIds, setEditableTPStatusIds] = useState<number[]>([]);

  useEffect(() => {
    if (!tpStatuses) return;

    const statusIdForStartedTP = tpStatuses.find(
      (status: ITreatmentPlanStatus) => status.label === TreatmentPlanStatus.Started,
    )?.id;

    const statusIdForEditingTP = tpStatuses.find(
      (status: ITreatmentPlanStatus) => status.label === TreatmentPlanStatus.Editing,
    )?.id;

    setEditableTPStatusIds([statusIdForStartedTP, statusIdForEditingTP]);
  }, [tpStatuses]);

  useEffect(() => {
    if (
      areUserRolesIn(user?.roles, [Roles.Bcba, Roles.AssistantAssessor]) &&
      treatmentPlan &&
      editableTPStatusIds.includes(treatmentPlan?.status_id) &&
      provider &&
      (provider.id === treatmentPlan.provider_id ||
        areUserRolesIn(user?.roles, [Roles.AssistantAssessor]))
    ) {
      setIsEditable(true);
    } else {
      setIsEditable(false);
    }
  }, [user, provider, treatmentPlan, editableTPStatusIds]);

  return isEditable;
}
